import { FC, SVGProps } from 'react';

const DownChevron: FC<
  SVGProps<SVGSVGElement> & { size?: number; color?: string }
> = ({ color = '#2d2d2d', size = 24, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      color={color}
      viewBox="0 0 18 12"
      fill="none"
      {...props}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M2 2L9 9L16 2"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default DownChevron;
